import * as React from "react";
import { Button, StyleProp, TextInput, ViewStyle } from "react-native";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

import { Move } from "../../types";

import { Text, View } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useAutosave from "../../common/hooks/useAutosave";

import Video from "../video";
import Family from "../family";
import { Space } from "../../styled-component";
import { Family as FamilyType, Video as VideoType } from "../../types";

type MoveFormValues = Pick<Move, "name"> & {
  videos: VideoType["id"][];
  family: FamilyType["id"];
};

export interface MoveFormProps {
  move?: Move;
  style?: StyleProp<ViewStyle>;
  onSave?: (values: MoveFormValues) => void;
  disabled?: boolean;
}

function MoveForm({ move, style, onSave = _.noop, disabled }: MoveFormProps) {
  const { control, handleSubmit } = useForm<MoveFormValues>({
    defaultValues: {
      ...move,
      videos: move?.videos?.map((video) => video.id) || [],
      family: move?.family?.id,
    },
  });
  const [editingVideos, setEditingVideos] = React.useState(false);
  const [editingFamily, setEditingFamily] = React.useState(false);

  const save = useAutosave({
    onSave: handleSubmit(onSave),
  });

  return (
    <View>
      <Controller
        control={control}
        name="name"
        // rules={{
        //   required: true,
        // }}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <TextInput
              placeholder="Move"
              style={commonStyles.textInput}
              onBlur={onBlur}
              onChangeText={(text) => {
                onChange(text);
                save();
              }}
              value={value}
              editable={!disabled}
            />
          </>
        )}
      />

      <Space />

      <Controller
        control={control}
        name="family"
        // rules={{
        //   required: true,
        // }}
        render={({ field: { onChange, value, onBlur: _onBlur } }) => (
          <>
            {!disabled && (
              <>
                <Button
                  title={editingFamily ? "Done" : "Edit Family"}
                  onPress={() => setEditingFamily(!editingFamily)}
                />

                <Space />
              </>
            )}

            {editingFamily && (
              <Family.Input
                disabled
                value={value}
                onChange={(nextValue) => {
                  onChange(nextValue);
                  save();
                }}
              />
            )}

            {!editingFamily &&
              (move?.family ? (
                <Family.ListItem family={move.family} disabled />
              ) : (
                <Text>No Family</Text>
              ))}
          </>
        )}
      />

      <Space />

      <Controller
        control={control}
        name="videos"
        // rules={{
        //   required: true,
        // }}
        render={({ field: { onChange, value, onBlur: _onBlur } }) => (
          <>
            {!disabled && (
              <>
                <Button
                  title={editingVideos ? "Done" : "Edit Videos"}
                  onPress={() => setEditingVideos(!editingVideos)}
                />

                <Space />
              </>
            )}

            {editingVideos ? (
              <Video.Input
                value={value}
                onChange={(nextValue) => {
                  onChange(nextValue);
                  save();
                }}
              />
            ) : (
              <Video.Carousel videos={move?.videos} />
            )}
          </>
        )}
      />
    </View>
  );
}

export default MoveForm;
